module.exports = __webpack_public_path__ + "26f5286de767dcdb895d8b79ba2524f7.png";